/** Constants for contact point kinds and their display labels */
export const CONTACT_POINT_KIND = {
  EMAIL: 'EMAIL',
  PHONE_NUMBER: 'PHONE_NUMBER',
} as const;

export const CONTACT_POINT_LABELS: Record<string, string> = {
  [CONTACT_POINT_KIND.EMAIL]: 'Email',
  [CONTACT_POINT_KIND.PHONE_NUMBER]: 'Phone',
};

/** Get a user-friendly label for a contact point kind */
export const getContactPointLabel = (kind: string | null): string => {
  if (!kind) return '-';
  return CONTACT_POINT_LABELS[kind] || kind;
};
